import React from 'react';

import { useAnalyticsFilesTableContext } from './AnalyticsFilesTableContext';
import { analyticsFilesTableColumns } from './analyticsFilesTableColumns';
import AnalyticsFilesTableTitle from './AnalyticsFilesTableTitle';

const STATIC_TABLE_PROPS = {
  columns: analyticsFilesTableColumns,
  title: <AnalyticsFilesTableTitle />,
  sortServer: true,
  paginationDefaultPage: 1,
};

export default function useAnalyticsFilesTable() {
  const { setActivePage, analyticsFiles, pagination, loading, resetPagination, perPage, onSort } =
    useAnalyticsFilesTableContext();

  return {
    ...STATIC_TABLE_PROPS,
    data: analyticsFiles,
    pagination,
    onSort,
    loading,
    perPage,
    paginationResetDefaultPage: resetPagination,
    onFetchPage: setActivePage,
  };
}
